export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5186.22b7de67.jpg";